<template lang="pug">
div
	v-img.py-8.px-md-12.white--text.mb-6(src="https://static.wintersport.nl/images/nskiv/healthcare.jpg" :aspect-ratio="10" gradient="180deg,rgba(37, 63, 86, 0.6) 0,rgba(2, 11, 31, 0.6)" height="auto")
		.text-center
			h1.h2.display-3.font-weight-bold {{$t('page.insurance.health:heading')}}
			.h4.title.font-weight-bold {{$t('page.insurance.health:intro')}}
		v-container
			v-row
				v-col(cols="12")
					v-card.flex.d-flex.flex-column.pa-md-3(flat color="rgba(255, 255, 255, 0.8)" height="100%")
						v-card-text.flex.font-weight-bold.accent--text
							h2 Onze zorgverzekering biedt
							v-row(dense)
								v-col.shrink
									ws-icon(color="success" small) check
								v-col Tot 10% korting op aanvullende en tandartsverzekeringen
							v-row(dense)
								v-col.shrink
									ws-icon(color="success" small) check
								v-col 100% acceptatie
							v-row(dense)
								v-col.shrink
									ws-icon(color="success" small) check
								v-col Buitenlanddekking voor de hele wereld
							v-row(dense)
								v-col.shrink
									ws-icon(color="success" small) check
								v-col Eén telefoonnummer voor de alarmcentrales van je zorg- en reisverzekering
							v-row(dense)
								v-col.shrink
									ws-icon(color="success" small) check
								v-col Eigen online omgeving en Zorgapp voor snel declareren
							v-row(dense)
								v-col.shrink
									ws-icon(color="success" small) check
								v-col Geen preferentiebeleid geneesmiddelen
				//- v-col(cols="12" md="6")
					v-card.flex.d-flex.flex-column.pa-md-3(flat color="rgba(255, 255, 255, 0.8)" height="100%")
						v-card-text.flex.font-weight-bold.accent--text
							h2 Wintersportvoordelen
							v-row(dense)
								v-col.shrink
									ws-icon(color="success" small) check
								v-col 10 extra fysiotherapiebehandelingen na wintersportongeval
							v-row(dense)
								v-col.shrink
									ws-icon(color="success" small) check
								v-col Vergoeding van steunzolen voor skischoenen
							v-row(dense)
								v-col.shrink
									ws-icon(color="success" small) check
								v-col Vergoeding van skibril op sterkte
							v-row(dense)
								v-col.shrink
									ws-icon(color="success" small) check
								v-col Vergoeding van cursus ‘stoeltjesliftangst’ of ‘Eerste Hulp Bij Bergsport Ongevallen’
	.text-center
		h2 de Basisverzekering
		p In Nederland is de basisverzekering verplicht. De overheid bepaalt ieder jaar opnieuw welke zorg hierin zit. Bij iedere verzekeraar is dit dus hetzelfde. Wat wel kan verschillen is de vrijheid om je eigen zorgverlener te kiezen. Wij bieden twee verschillende basisverzekeringen aan.
	v-container
		v-row(justify="center")
			v-col(cols="12" md="6" lg="5")
				v-card.flex.d-flex.flex-column(outlined height="100%")
					v-sheet.text-center.pa-3.accent--text(color="info")
						h3.headline.font-weight-bold.mb-0 Zorg natura
						p.mb-0 Goede zorg én een lage premie
						.title.font-weight-bold € 147,95 p.m.
						.caption bij een standaard eigen risico van €385,-.
					v-divider
					v-card-text.flex.font-weight-bold.accent--text
						v-row(dense)
							v-col.shrink
								ws-icon(color="success" small) check
							v-col Je kunt naar je eigen huisarts en bij spoedeisende hulp naar ieder ziekenhuis.
						v-row(dense)
							v-col.shrink
								ws-icon(color="success" small) check
							v-col 100% vergoeding bij gecontracteerde zorgaanbieders.
						v-row(dense)
							v-col.shrink
								ws-icon(color="success" small) check
							v-col 80% vergoeding bij niet-gecontracteerde zorgaanbieders.
					v-card-actions
						v-spacer
						v-btn(depressed color="warning" href="https://aanvragen.aevitae.com/nl/610002" target="_blank" rel="nofollow") bereken premie
						v-spacer
			v-col(cols="12" md="6" lg="5")
				v-card.flex.d-flex.flex-column(outlined height="100%")
					v-sheet.text-center.pa-3.accent--text(color="info")
						h3.headline.font-weight-bold.mb-0 Zorg Restitutie
						p.mb-0 Compleet vrij in keuze zorgverlener
						.title.font-weight-bold € 160,95 p.m.
						.caption bij een standaard eigen risico van €385,-.
					v-divider
					v-card-text.flex.font-weight-bold.accent--text
						v-row(dense)
							v-col.shrink
								ws-icon(color="success" small) check
							v-col Je kunt naar je eigen huisarts en bij spoedeisende hulp naar ieder ziekenhuis.
						v-row(dense)
							v-col.shrink
								ws-icon(color="success" small) check
							v-col Vrije keuze zorgaanbieders.
						v-row(dense)
							v-col.shrink
								ws-icon(color="success" small) check
							v-col 100% vergoeding van het marktconforme tarief.
					v-card-actions
						v-spacer
						v-btn(depressed color="warning" href="https://aanvragen.aevitae.com/nl/610002" target="_blank" rel="nofollow") bereken premie
						v-spacer

	.my-6
		h2 Aanvullende verzekeringspakketten
		p Wil je extra zorg die goed past bij jouw persoonlijke situtatie? De basisverzekering, die voor iedereen in Nederland gelijk is, kan je uitbreiden met één van onze vier aanvullende verzekeringen.
		v-simple-table.coverage-table.mb-6
			tbody
				tr
					th.nb
					th.accent--text
						| Prettig
						p
							ws-icon(small color="accent") snowflake
					th.accent--text
						| Prima
						p
							ws-icon(small color="accent") snowflake
							ws-icon(small color="accent") snowflake
					th.accent--text
						| Populair
						p
							ws-icon(small color="accent") snowflake
							ws-icon(small color="accent") snowflake
							ws-icon(small color="accent") snowflake
					th.accent--text
						| Ruim
						p
							ws-icon(small color="accent") snowflake
							ws-icon(small color="accent") snowflake
							ws-icon(small color="accent") snowflake
							ws-icon(small color="accent") snowflake
					th.accent--text 
						| Riant
						p
							ws-icon(small color="accent") snowflake
							ws-icon(small color="accent") snowflake
							ws-icon(small color="accent") snowflake
							ws-icon(small color="accent") snowflake
							ws-icon(small color="accent") snowflake
				tr
					th.accent--text Fysiotherapie
					td 6 behandelingen
					td 9 behandelingen
					td 12 behandelingen
					td 21 behandelingen
					td 36 behandelingen
				tr
					th.accent--text Brillen
					td Geen
					td Geen
					td € 100 per 2 kalenderjaren
					td € 150 per 2 kalenderjaren
					td € 250 per 2 kalenderjaren
				tr
					th.accent--text Alternatieve geneeswijzen
					td Geen
					td Geen
					td € 40 per dag tot € 350 per jaar
					td € 50 per dag tot € 550 per jaar
					td € 50 per dag tot € 750 per jaar
				tr
					th.nb
					td.font-weight-bold.accent--text € 4,38 p.m.
					td.font-weight-bold.accent--text € 8,27 p.m.
					td.font-weight-bold.accent--text € 24,94 p.m.
					td.font-weight-bold.accent--text € 43,65 p.m.
					td.font-weight-bold.accent--text € 67,40 p.m.
		v-row(dense justify="center")
			v-col.shrink
				ws-icon(small) download
			v-col
				<a href="https://download.wintersport.nl/media/downloads/2023/12/11/vergoedingenoverzicht-basisverzekering-natura-11-12-2023.pdf" target="_blank" title="Vergoedingenoverzicht 2024 Nederlandse Ski Vereniging Aanvullende Pakketten">Vergoedingenoverzicht 2024 Nederlandse Ski Vereniging Aanvullende Pakketten</a>
	.mb-6
		h2 Tandarts verzekeringspakketten
		p Naast een aanvullende verzekering kan je je basisverzekering ook uitbreiden met een tandarts verzekering. Met een tandartsverzekering ben je verzekerd tegen de meest voorkomende tandartskosten.
		v-simple-table.coverage-table.mb-6
			tbody
				tr
					th.nb
					th.accent--text
						| Tand 250
					th.accent--text
						| Tand 500
					th.accent--text
						| Tand 750
				tr
					th.accent--text Kosten van tandheelkundige behandelingen
					td 100% vergoed, maximaal € 250 per jaar*
					td 100% vergoed, maximaal € 500 per jaar*
					td 100% vergoed, maximaal € 750 per jaar*
				//- tr
					th.accent--text Overige behandelingen uitgevoerd door een tandarts of mondhygiënist
					td 80% vergoed, maximaal € 250 per jaar*
					td 80% vergoed, maximaal € 500 per jaar*
					td 80% vergoed, maximaal € 750 per jaar*
				tr
					th.accent--text Tandheelkundige zorg na een ongeval (na toestemming**)
					td € 10.000 per ongeval**
					td € 10.000 per ongeval**
					td € 10.000 per ongeval**
				//- tr
					th.nb
					td.font-weight-bold.accent--text € 17,89 p.m.
					td.font-weight-bold.accent--text € 24,73 p.m.
					td.font-weight-bold.accent--text € 41,83 p.m.

		v-simple-table.coverage-table.mb-6
			tbody
				tr
					th.nb
					th.accent--text
						| 18-21 jaar
					th.accent--text
						| Vanaf 22 jaar
				tr
					th.accent--text Tand 250
					td.font-weight-bold.accent--text € 12,46
					td.font-weight-bold.accent--text € 17,80
				tr
					th.accent--text Tand 500
					td.font-weight-bold.accent--text € 23,39
					td.font-weight-bold.accent--text € 32,05
				tr
					th.accent--text Tand 750
					td.font-weight-bold.accent--text € 35,21
					td.font-weight-bold.accent--text € 48,48


		.text-center.mb-6
			v-btn(depressed color="warning" href="https://aanvragen.aevitae.com/nl/610002" target="_blank" rel="nofollow") bereken premie
		.caption *Dit maximum geldt voor alle tandheelkundige behandlingen tezamen per jaar.
		.caption **Voor deze zorg heb je vooraf toestemming nodig van Aevitae. Nadat we jouw aanvraag hebben ontvangen, ontvang je binnen 10 werkdagen een reactie van ons. Raadpleeg de verzekeringsvoorwaarden.
	v-row
		v-col(cols="12" md="8")
			h2 Eigen risico
			p Voor 2024 geldt een verplicht eigen risico van € 385,-. Het is daarnaast mogelijk om te kiezen voor een extra vrijwillig eigen risico van € 500. Dit scheelt je per maand € 17,50 aan premie.

			h2 Belangrijke documenten voor verzekerden
			v-row(dense)
				v-col.shrink
					ws-icon(small) download
				v-col <a href="https://download.wintersport.nl/media/downloads/2023/12/11/polisvoorwaarden-basisverzekering-natura-11-12-2023.pdf" target="_blank" title="Voorwaarden basisverzekering Natura">Voorwaarden basisverzekering Natura</a>
			v-row(dense)
				v-col.shrink
					ws-icon(small) download
				v-col <a href="https://download.wintersport.nl/media/downloads/2023/12/11/polisvoorwaarden-basisverzekering-restitutie-11-12-2023.pdf" target="_blank" title="Voorwaarden basisverzekering Restitutie">Voorwaarden basisverzekering Restitutie</a>
			v-row(dense)
				v-col.shrink
					ws-icon(small) download
				v-col <a href="https://download.wintersport.nl/media/downloads/2023/12/11/polisvoorwaarden-prettig,-prima,-populair,-ruim,-riant-11-12-2023.pdf" target="_blank" title="Voorwaarden Prettig, Prima, Populair, Ruim, Riant">Voorwaarden Prettig, Prima, Populair, Ruim, Riant</a>
			v-row(dense)
				v-col.shrink
					ws-icon(small) download
				v-col <a href="https://download.wintersport.nl/media/downloads/2021/11/23/22081_aev_reglement_hulpmiddelen_2022-23-11-2021.pdf" target="_blank" title="Reglement Hulpmiddelen 2022">Reglement Hulpmiddelen 2022</a>
			v-row(dense)
				v-col.shrink
					ws-icon(small) download
				v-col <a href="https://download.wintersport.nl/media/downloads/2022/12/01/reglement-farmaceutische-zorg-2023-01-12-2022.pdf" target="_blank" title="Reglement Farmaceutische zorg 2023">Reglement Farmaceutische zorg 2023</a>
			v-row(dense)
				v-col.shrink
					ws-icon(small) download
				v-col <a href="https://download.wintersport.nl/media/downloads/2022/12/01/reglement-persoonsgebonden-budget-verpleging-en-verzorging-2023-01-12-2022.pdf" target="_blank" title="Reglement Persoonsgebonden budget verpleging en verzorging">Reglement Persoonsgebonden budget verpleging en verzorging</a>
			v-row(dense)
				v-col.shrink
					ws-icon(small) download
				v-col <a href="https://download.wintersport.nl/media/downloads/2020/12/09/reglement-niet-gecontracteerde-verpleging-en-verzorging-2021-09-12-2020.pdf" target="_blank" title="Reglement niet-gecontracteerde verpleging en/of verzorging">Reglement niet-gecontracteerde verpleging en/of verzorging</a>
			v-row(dense)
				v-col.shrink
					ws-icon(small) download
				v-col <a href="https://download.wintersport.nl/media/downloads/2023/12/11/vergoedingenoverzicht-basisverzekering-natura-11-12-2023.pdf" target="_blank" title="Vergoedingenoverzicht 2024 basisverzekering Natura">Vergoedingenoverzicht 2024 basisverzekering Natura</a>
			v-row(dense)
				v-col.shrink
					ws-icon(small) download
				v-col <a href="https://download.wintersport.nl/media/downloads/2023/12/11/vergoedingenoverzicht-basisverzekering-restitutie-11-12-2023.pdf" target="_blank" title="Vergoedingenoverzicht 2024 basisverzekering Restitutie">Vergoedingenoverzicht 2024 basisverzekering Restitutie</a>
			v-row(dense)
				v-col.shrink
					ws-icon(small) download
				v-col <a href="https://download.wintersport.nl/media/downloads/2023/12/11/vergoedingenoverzicht-prettig,-prima,-populair,-ruim,-riant-11-12-2023.pdf" target="_blank" title="Vergoedingenoverzicht 2024 Prettig, Prima, Populair, Ruim, Riant">Vergoedingenoverzicht 2024 Prettig, Prima, Populair, Ruim, Riant</a>

			v-row(dense)
				v-col.shrink
					ws-icon(small) download
				v-col <a href="https://download.wintersport.nl/media/downloads/2022/12/01/vergoedingenoverzicht-2023-aanvullende-verzekeringen-01-12-2022.pdf" target="_blank" title="Vergoedingenoverzicht 2023 Nederlandse Ski Vereniging Aanvullende Pakketten">Vergoedingenoverzicht 2023 Nederlandse Ski Vereniging Aanvullende Pakketten</a>
			v-row(dense)
				v-col.shrink
					ws-icon(small) download
				v-col <a href="https://download.wintersport.nl/media/downloads/2023/12/11/vergoedingenoverzicht-aevitae-tandartspakketten-11-12-2023.pdf" target="_blank" title="Vergoedingenoverzicht 2024 Nederlandse Skivereniging Tandartspakketten">Vergoedingenoverzicht 2024 Nederlandse Skivereniging Tandartspakketten</a>
			v-row(dense)
				v-col.shrink
					ws-icon(small) download
				v-col <a href="https://download.wintersport.nl/media/downloads/2022/12/01/polisvoorwaarden-2023-aanvullende-verzekeringen-01-12-2022.pdf" target="_blank" title="Polisvoorwaarden 2023 Nederlandse Skivereniging Aanvullende Verzekering">Polisvoorwaarden 2023 Nederlandse Skivereniging Aanvullende Verzekering</a>
			v-row(dense)
				v-col.shrink
					ws-icon(small) download
				v-col <a href="https://download.wintersport.nl/media/downloads/2023/12/11/polisvoorwaarden-aevitae-tandartspakketten-11-12-2023.pdf" target="_blank" title="Polisvoorwaarden 2024 Nederlandse Skivereniging Tandarts Pakketten">Polisvoorwaarden 2024 Nederlandse Skivereniging Tandarts Pakketten</a>
		v-col(cols="12" md="4")
			v-card.mb-4(outlined color="info")
				v-card-text.accent--text
					.subtitle-1.font-weight-bold Nederlandse Ski Vereniging
					v-row(dense)
						v-col.shrink
							ws-icon(small) information-circle
						v-col
							a.external(href="/verzekering/meestgestelde-vragen" target="_blank") Meestgestelde vragen
					v-row(dense)
						v-col.shrink
							ws-icon(small) envelope
						v-col
							a.external(href="mailto:verzekeren@wintersport.nl" target="_blank" rel="nofollow") verzekeren@wintersport.nl
					v-row(dense)
						v-col.shrink
							ws-icon(small) phone
						v-col
							a.external(href="tel:+3130307781" target="_blank" rel="nofollow") 030 30 77 812
					.caption Bereikbaar op werkdagen tussen 08:30 en 17:30 uur
					.subtitle-1.font-weight-bold.mt-6 Voor zorginhoudelijke vragen
					p.mb-0 Aevitae Service Desk
					v-row(dense)
						v-col.shrink
							ws-icon(small) phone
						v-col
							a.external(href="tel:+31883535763" target="_blank" rel="nofollow") 088 353 5763
					.caption Bereikbaar op werkdagen tussen 09:00 en 17:00 uur

</template>

<style lang="sass">
.coverage-table
	table
		table-layout: fixed
		border-collapse: collapse
		width: 100%

	tr
		th:first-child
			width: 300px
			border-left: 1px solid #ddd

	tr:first-child th:first-child
		border-left: none
		border-top: none

	tr:last-child
		td
			border-bottom: 1px solid #ddd
		th
			border-left: none

	td, th
		padding: $spacer * 2
		border-right: 1px solid #ddd
		vertical-align: top

	th
		border-top: 1px solid #ddd
		background-color: var(--v-info-base)
		text-align: left
		&.nb
			background: none
</style>

<script>
export default {
	name: 'InsuranceHealth',
	nuxtI18n: {
		paths: {
			'nl-NL': '/verzekering/zorgverzekering'
		}
	},
	scrollToTop: true,
	asyncData({ app }) {
		app.ads({});
		app.meta({
			title: 'Zorgverzekering - Nederlandse Ski Vereniging',
			description:
				'De Nederlandse Ski Vereniging zorgt ervoor dat jij zo onbezorgd mogelijk op wintersport kan gaan. Om die reden ontwikkelden wij ook een zorgverzekering die perfect aansluit op onze doorlopende reisverzekering.',
			hasFollow: true,
			hasIndex: true
		});
		app.breadcrumbs({
			[app.i18n.t('page.insurance:breadcrumb')]: { name: 'verzekering' },
			[app.i18n.t('page.insurance.health:breadcrumb')]: {
				name: 'verzekering-zorgverzekering'
			}
		});
	},
	head() {
		return {
			...this.$structuredData()
			//
		};
	}
};
</script>
